var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.208002 13.578L13.578 0.208002C13.902 -0.116998 14.491 -0.0539976 14.893 0.347002C15.294 0.749002 15.357 1.338 15.032 1.662L1.662 15.032C1.338 15.357 0.749002 15.294 0.347002 14.893C-0.0539976 14.491 -0.116998 13.902 0.208002 13.578Z",
    fill: "#F2E6C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.662 0.208002L15.032 13.578C15.357 13.902 15.294 14.491 14.893 14.893C14.491 15.294 13.902 15.357 13.578 15.032L0.208002 1.662C-0.116998 1.338 -0.0539976 0.749002 0.347002 0.347002C0.749002 -0.0539976 1.338 -0.116998 1.662 0.208002Z",
    fill: "#F2E6C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.7218b2ad359c64620a00fb5d97efd922.svg";
export { ForwardRef as ReactComponent };